<script>
import fieldMixin from '@maison/mixins/fieldMixin';
import RadioField from '@maison/components/form/fields/RadioField';
import { useField } from '@phoenix/composables/field';

export default {
  components: {
    RadioField,
  },

  mixins: [fieldMixin],

  props: {
    inline: {
      type: Boolean,
      default: false,
    },
  },

  setup(props) {
    return useField(props);
  },

  computed: {
    ariaLabelledby() {
      return `${this.field.id}-label`;
    },

    listClass() {
      if (this.inline && this.isSgphx) {
        return 'sgphx-radios-inline__list';
      }

      return this.inline ? 'radios-inline__list' : '';
    },
  },

  methods: {
    getOptionAttrs(option) {
      return {
        name: this.field.name,
        required: this.field.required,
        scope: this.field.scope,
        ...option,
      };
    },
  },
};
</script>

<template>
  <ul :class="listClass" :aria-labelledby="ariaLabelledby">
    <li v-for="option in field.options" :key="option.id">
      <radio-field
        v-model="value"
        :parent-id="field.id"
        :attrs="getOptionAttrs(option)"
        :should-validate="false"
        :is-sgphx="isSgphx"
      />
    </li>
  </ul>
</template>
